import createFaceDetector from './detectors/faceDetector'
import {
    createObjectDetector,
    createPetDetector,
} from './detectors/objectDetector'
import createColorDetector from './detectors/colorDetector'
import createMotionDetector from './detectors/motionDetector'
import createGestureDetector from './detectors/gestureDetector'
import createTrackingDetector from './detectors/trackingDetector'
import createMarkerDetector from './detectors/markerDetector'
import createOcrDetector from './detectors/ocrDetector'
import createSpeechDetector from './detectors/speechDetector'
import createPartCountDetector from './detectors/partCountDetector'

export const DETECTOR_FACTORIES = [
    createFaceDetector,
    createObjectDetector,
    createTrackingDetector,
    createPartCountDetector,
    createGestureDetector,
    createPetDetector,
    createColorDetector,
    createMarkerDetector,
    createOcrDetector,
    createSpeechDetector,
    createMotionDetector,
]

export function buildDetectors() {
    return DETECTOR_FACTORIES.map((factory) => factory())
}

export const DETECTOR_OPTIONS = DETECTOR_FACTORIES.map((factory) => {
    const d = factory()
    return {
        id: d.id,
        label: d.label,
        accent: d.accent,
        comingSoon: !!d.comingSoon,
    }
})
